// extracted by mini-css-extract-plugin
export default {"projectCard":"ProjectCard_projectCard__cPUly","projectFooter":"ProjectCard_projectFooter__seyye","projectImage":"ProjectCard_projectImage__AMXdl"};